export default "__VITE_ASSET__9cb51481__"